import { Component, ElementRef, Input, output, ViewChild } from '@angular/core';

import { IconComponent } from '../../icon/icon.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'work-ui-accordion-item',
  standalone: true,
  imports: [IconComponent, NgClass],
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss'],
})
export class AccordionItemComponent {
  @ViewChild('heading') headingElement: ElementRef | undefined;
  @Input() isOpen = false;
  @Input() isDisabled = false;
  @Input() withBorder = true;
  @Input() noPadding = false;
  @Input() hideIcon = false;
  @Input() headerNoHoverEffect = false;
  @Input() headerIconSpaceBetween = true;
  /**
   * Public, damit Aufrufer auf das Auf-/Zuklappen reagieren können — z.B. um den Inhalt erst beim
   * Öffnen zu instanziieren. Der Accordion-Inhalt liegt sonst immer im DOM (nur CSS-getoggelt), was
   * bei teuren Inhalten wie PDF-Viewern nicht tragbar ist.
   */
  public accordionToggled = output<boolean>();

  toggle() {
    if (this.isDisabled) {
      return;
    }

    this.isOpen = !this.isOpen;
    this.accordionToggled.emit(this.isOpen);
  }
}
